import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable } from 'rxjs';
import { Page } from '@rx-lib/ui';


@Injectable({
  providedIn: 'root'
})
export class RestService {
  private http: HttpClient = inject(HttpClient);

  getAllPages(url: string): Observable<Page[]> {
    return this.http.get<Page[]>(url + '/data/content?_format=json');
  }

  getMenu(url: string): Observable<Route[]> {
    return this.http.get<Route[]>(url + '/entity/menu/main?_format=json');
  }

}
